import { Title } from '../Title'
import { Label } from './styled'

export type TaxiparkProps = {
  name?: string
}

export function Taxipark({ name }: TaxiparkProps) {
  return (
    <div>
      <Title>Таксопарк</Title>

      <Label>{name ? name : 'Таксопарк не найден! Уточните у оператора'}</Label>
    </div>
  )
}
